const ePlayBookView = {
  PlayBookList: 1,
  CreatePlayBook: 2,
  EditPlayBook: 3
};

export default ePlayBookView;
